import platformConstants from "../constants/platformConstants";

const retrievePlatforms = (payload: any) => ({
  type: platformConstants.GET_PLATFORMS_LIST,
  payload,
});

export const createPlatform = (payload: any) => ({
  type: platformConstants.CREATE_PLATFORM_REQUEST,
  payload,
});

export const editPlatform = (id: string, payload: any) => ({
  type: platformConstants.EDIT_PLATFORM_REQUEST,
  id,
  payload,
});

export const resetPlatform = () => ({
  type: platformConstants.RESET_PLATFORM_REQUEST,
});

export const resetPlatformList = () => ({
  type: platformConstants.RESET_PLATFORM_LIST,
});

export default retrievePlatforms;
